var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.1094H22V24H0V21.1094ZM8.71697 5.8471H13.2856V20.599H8.71697V5.8471ZM16.0729 10.5759H20.6416V20.599H16.0729V10.5759ZM1.35986 13.9053H5.92849V20.5998L1.35986 20.5987V13.9053ZM3.64357 8.17798L4.15068 9.75536L5.8002 9.752L4.46386 10.7237L4.97656 12.2989L3.64355 11.3227L2.31053 12.2989L2.82324 10.7237L1.48689 9.752L3.13641 9.75536L3.64357 8.17798ZM18.3578 4.75231L18.8649 6.3297L20.5144 6.32634L19.1781 7.29807L19.6908 8.87322L18.3578 7.89702L17.0248 8.87322L17.5375 7.29807L16.2011 6.32634L17.8506 6.3297L18.3578 4.75231ZM11.0007 0L11.5078 1.57627L13.1573 1.57291L11.821 2.54464L12.3337 4.11979L11.0007 3.14359L9.66765 4.11979L10.1803 2.54464L8.844 1.57291L10.4935 1.57627L11.0007 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellence);
export default __webpack_public_path__ + "static/media/Excellence.4511a354eff0944a21b210ac1a016aa4.svg";
export { ForwardRef as ReactComponent };